import React from 'react';
import { SetCoHostProps } from './SetCoHost.type';
import { useTranslation } from 'react-i18next';
import './SetCoHost.scss';
import wemeetClient from '@utils/wemeetClient';
import { BOOL, HostType } from '@tencent/wemeet-websdk-next';
import { message } from '@tencent/tea-component';

const SetCoHost: React.FC<SetCoHostProps> = ({ user }) => {
  const { t } = useTranslation();
  const onSetCoHost = async () => {
    if (user.id) {
      const res = await wemeetClient.hostCtrl.changeHost(user.id, HostType.cohost, BOOL.true);
      if (res) {
        message.error({
          content: res?.message ?? t('切换失败'),
        });
      }
    }
  };
  return (
    <li className="set-co-host" onClick={onSetCoHost}>
      {t('设为联席主持人')}
    </li>
  );
};

export default SetCoHost;
